import { ref, watch } from 'vue'
import { useGetSearchObjects } from '@/widgets/ObjectSearch/model/api'
import { debounce } from 'lodash'
import type { ObjectSearchType } from './types'
import { useAuth } from '@/entities/Auth'
import { useTranslate } from '@/shared/lib'

export const useModel = (object_type = 0, mock = false) => {
  const search = ref('')
  const list = ref<ObjectSearchType[]>([])
  const auth = useAuth()
  const { trs } = useTranslate()

  /**
   * Загрузка данных и обработка полученных данных
   */
  const result = useGetSearchObjects(search, object_type)

  watch(result.data, () => {
    const data = result.data.value?.data || []

    list.value = data.map((item) => {
      let parents = item.parents_name?.split(' / ') || []
      const index = parents.indexOf(auth.user?.object_group.name)

      if (index !== -1) parents = parents.slice(index + 1)

      return { ...item, parents_name: parents.length ? parents.join(' / ') : trs('itf.root') }
    })
  })

  /**
   * Функция получения новых данных при изменении запроса
   */
  const reloadData = debounce(() => {
    if (mock) {
      clearHandler()
      return
    }
    search.value.length > 2 ? result.refetch() : clearHandler()
  }, 500)

  /**
   * Функция очистки списка данных
   */
  const clearHandler = () => {
    list.value = []
  }

  return {
    search,
    list,

    reloadData,
    clearHandler,

    ...result,
  }
}
